import { DateTimeFormatter } from '../formatters/date-time-formatter';
import { UnitFormatter } from '../formatters/unit-formatter';
import { TimeSettings, UnitSettings } from './settings';

export type ChangeEvent = 'unitsChanged' | 'timeSettingsChanged';

// TODO: improve this, this is technically global state and should be managed as such
// TODO: convert this to use Evented maplibre base class...
class _StateManager {
    private _units: UnitSettings;
    private _time: TimeSettings;

    constructor() {
        this._units = {
            fobVolume: 0,
            fobWeight: 0,
            latLngFormat: 0,
            distanceUnit: 0
        };

        this._time = {
            timeZone: 0,
            timeFormat: 0,
            dateFormat: 0,
            dateDelimiter: 0,
            showDaysWithTime: false
        };
    }

    private readonly _callbacks: { [key in ChangeEvent]: ((arg: any) => void)[] } = {
        unitsChanged: [],
        timeSettingsChanged: []
    };

    public get units() {
        return this._units;
    }

    public get time() {
        return this._time;
    }

    public myFleetIsLoading: boolean = true;

    logJsonMessages = false;

    updateUnits(newUnits: UnitSettings) {
        this._units = newUnits;
        this._callbacks.unitsChanged.forEach((x) => x.apply(null, [this._units]));
        UnitFormatter.setProps(newUnits);
    }

    updateTime(newTime: TimeSettings) {
        this._time = newTime;
        this._callbacks.timeSettingsChanged.forEach((x) => x.apply(null, [this._time]));
        DateTimeFormatter.setProps(newTime);
    }

    on(event: 'unitsChanged', callback: (view: UnitSettings) => void): void;
    on(event: 'timeSettingsChanged', callback: (view: TimeSettings) => void): void;
    on(event: ChangeEvent, callback: (view: any) => void): void;
    on(event: ChangeEvent, callback: (view: any) => void): void {
        if (this._callbacks[event].indexOf(callback) === -1) {
            this._callbacks[event].push(callback);
        }
    }

    off(event: ChangeEvent, callback: (view: any) => void): void {
        const idx = this._callbacks[event].indexOf(callback);
        if (idx !== -1) {
            this._callbacks[event].splice(idx, 1);
        }
    }
}

/**
 * @deprecated Use {@link FlightWorkerGlobal} for new things
 */
export const StateManager = new _StateManager();
